export enum StoreDirectorySortBy {
    MostPopular = "most_popular",
    Name = "name",
    NameDesc = "name_desc",
    Newest = "newest",
    Relevance = "relevance",
}

export type StoreCatalogSortBy =
    | StoreDirectorySortBy.MostPopular
    | StoreDirectorySortBy.Name
    | StoreDirectorySortBy.NameDesc
    | StoreDirectorySortBy.Newest;
